import HeroLayout5 from "components/common/hero/HeroLayout5";
import PlatformSection from "components/home-page/PlatformSection";
import GlobalLayout from "components/page/GlobalLayout";
import React from "react";
import { Helmet } from "react-helmet";
import { buildMediaUrl } from "../utils";

const BreakUpWithNVRPage = () => {
  return (
    <GlobalLayout color="var(--secondary-bg)">
      <Helmet>
        <title>
          Break Up with On Prem NVR, Transition to Cloud | Book Demo | Rhombus
        </title>
        <meta
          name="description"
          content="It's time to break up with your on-premise NVR! Watch the viral on-premise NVR break up video and contact our team today for a live demo to learn why modern organizations are choosing Rhombus for smarter, simpler physical security."
        />
      </Helmet>
      <HeroLayout5
        title={"Break Up With Your On-Premise NVR!"}
        blurb={
          "We know breakups are hard—but moving to the cloud makes it easier. It's time to move on from outdated NVRs and discover a smarter, safer future with cloud-managed physical security. No drama, no regrets—just a better way to protect what matters."
        }
        formTitle={"Experience Rhombus. Request a Demo."}
        formId={"0266a6a5-9b89-4a80-b0eb-c3adbe32587a"}
        video={{
          src: buildMediaUrl("nvr-break-up-video.webm"),
          playbackRate: 1,
          showControls: true,
          muted: false,
          autoPlay: false,
          loop: false,
        }}
        titleWidth="600px"
      />
      <PlatformSection useLinks={false} />
    </GlobalLayout>
  );
};

export default BreakUpWithNVRPage;
